import { Controller } from "@hotwired/stimulus"

import $ from 'jquery'

$.fn.highlight = function (color) {
  $(this).each(function () {
    var el = $(this);
    $("<div></div>")
      .width(el.outerWidth())
      .height(el.outerHeight())
      .css({
        "position": "absolute",
        "left": el.offset().left,
        "top": el.offset().top,
        "background-color": color || "#ffff99",
        "opacity": ".7",
        "z-index": "9999999"
      }).appendTo('body').fadeOut(1000).queue(function () { $(this).remove(); });
  });
}

export default class extends Controller {
  connect() {
    // // TODO: Replace with show-if stimulus controller
    showOrHidePreGateChecksOnOrganizationAdvancedForm();
    showOrHideVerifyBolOrDoOnPreGateIn();
    showOrHideTallyConfirmationSettingsOnOrganizationAdvancedForm();
    showOrHideVoyageNumberFormatOnOrganizationAdvancedForm();
    showOrHideHideContainerSealNumbersAtTallyOnOrganizationAdvancedForm();
    showOrHideTrackChassisSubSettings();
    showOrHideUnlessChassisBookingIsOnOrganizationAdvancedForm();

    $('#organization_show_confirmation_modal_during_tallies').change(function (evt) {
      showOrHideTallyConfirmationSettingsOnOrganizationAdvancedForm();
    });

    $('#organization_automatically_generate_voyage_numbers').change(function (evt) {
      showOrHideVoyageNumberFormatOnOrganizationAdvancedForm();
    });

    $('#organization_accept_booking_for_chassis_only_interchanges').change(function (evt) {
      showOrHideUnlessChassisBookingIsOnOrganizationAdvancedForm();
    });

    $('#organization_has_pre_gates').change(function (_event) {
      showOrHidePreGateChecksOnOrganizationAdvancedForm();
    });

    $('#organization_verify_container_seal_at_tally').change(function (evt) {
      showOrHideHideContainerSealNumbersAtTallyOnOrganizationAdvancedForm();
    });
    $('#organization_verify_delivery_order_on_pre_gate_in').change(function (_event) {
      showOrHideVerifyBolOrDoOnPreGateIn();
    });

    $('#organization_track_chassis_movements').change(function (_event) {
      showOrHideTrackChassisSubSettings();
    });

    // Uncheck delivery order validation when validating BOL
    if ($('#organization_verify_bol_on_pre_gate_in').length) {
      $('#organization_verify_bol_on_pre_gate_in').on('change', function () {
        if ($(this).is(':checked') && $('#organization_verify_delivery_order_on_pre_gate_in').length) {
          $('#organization_verify_delivery_order_on_pre_gate_in').prop('checked', false)
        }
      })
    }

    // Uncheck BOL validation when validating delivery order
    if ($('#organization_verify_delivery_order_on_pre_gate_in').length) {
      $('#organization_verify_delivery_order_on_pre_gate_in').on('change', function () {
        if ($(this).is(':checked')) {
          $('#organization_verify_bol_on_pre_gate_in').prop('checked', false)
        }
      })
    }

    function showOrHideTallyConfirmationSettingsOnOrganizationAdvancedForm() {
      var checked = $('#organization_show_confirmation_modal_during_tallies').is(':checked');
      if (checked) {
        $('.hide-if-no-tally-confirmation-modal').show().highlight();
      } else {
        $('.hide-if-no-tally-confirmation-modal').hide();
      }
    }

    function showOrHideVoyageNumberFormatOnOrganizationAdvancedForm() {
      var checked = $('#organization_automatically_generate_voyage_numbers').is(':checked');
      if (checked) {
        $('.hide-if-no-automatically-generate-voyage-numbers').show().highlight();
      } else {
        $('.hide-if-no-automatically-generate-voyage-numbers').hide();
      }
    }

    function showOrHideUnlessChassisBookingIsOnOrganizationAdvancedForm() {
      var checked = $('#organization_accept_booking_for_chassis_only_interchanges').is(':checked');
      if (checked) {
        $('.hide-unless-chassis-booking-is-on').show().highlight();
      } else {
        $('.hide-unless-chassis-booking-is-on').hide();
      }
    }

    function showOrHidePreGateChecksOnOrganizationAdvancedForm() {
      var checked = $('#organization_has_pre_gates').is(':checked');
      if (checked) {
        $('.hide-unless-pre-gate-is-on').show().highlight();
      } else {
        if ($('#organization_verify_booking_for_picking_up_empty_containers').length) {
          $('#organization_verify_booking_for_picking_up_empty_containers').prop('checked', false)
        }
        if ($('#organization_verify_bol_on_pre_gate_in').length) {
          $('#organization_verify_bol_on_pre_gate_in').prop('checked', false)
        }
        if ($('#organization_verify_delivery_order_on_pre_gate_in').length) {
          $('#organization_verify_delivery_order_on_pre_gate_in').prop('checked', false)
        }

        $('.hide-unless-pre-gate-is-on').hide();
      }
    }

    function showOrHideVerifyBolOrDoOnPreGateIn() {
      var checked = $('#organization_verify_delivery_order_on_pre_gate_in').is(':checked');
      if (checked) {
        $('.hide-unless-verify-do-on-pre-gate-in').show().highlight();
      } else {
        $('#organization_verify_bol_or_delivery_order_trucking_company_on_pre_gate_in').prop('checked', false);
        $('.hide-unless-verify-do-on-pre-gate-in').hide();
      }
    }

    function showOrHideHideContainerSealNumbersAtTallyOnOrganizationAdvancedForm() {
      var checked = $('#organization_verify_container_seal_at_tally').is(':checked');
      if (checked) {
        $('.hide-unless-verify_container_seal_at_tally-is-on').show().highlight();
      } else {
        $('.hide-unless-verify_container_seal_at_tally-is-on').hide();
      }
    }

    function showOrHideTrackChassisSubSettings() {
      const checked = $('#organization_track_chassis_movements').is(':checked');
      if (checked) {
        $('.hide-unless-track-chassis-is-on').show().highlight();
      } else {
        $('#organization_track_chassis_movements_at_gate').prop('checked', false)
        $('#organization_track_chassis_movements_at_yard').prop('checked', false)
        $('.hide-unless-track-chassis-is-on').hide();
      }
    }
  }
}
